import React from 'react';
import PropTypes from 'prop-types';
import CartModalBody from './CartModalBody';
import CartModalHeader from './CartModalHeader';
import CartModalFooter from './CartModalFooter';

class CartModal extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const {
            tax,
            total,
            subtotal,
            items,
            removeItem,
            currencyFormat,
            currencyDisplayCode,
            locale,
        } = this.props;
        const hasItems = items.length > 0;

        return (
            <React.Fragment>
                <div className='cart-modal__container'>
                    <div className='cart-modal__content'>
                        <CartModalHeader />

                        <CartModalBody
                            hasItems={hasItems}
                            items={items}
                            removeItem={removeItem}
                            currencyFormat={currencyFormat}
                            currencyDisplayCode={currencyDisplayCode}
                            locale={locale}
                        />
                    </div>
                </div>
                <CartModalFooter
                    tax={tax}
                    total={total}
                    subtotal={subtotal}
                    hasItems={hasItems}
                    currencyFormat={currencyFormat}
                    currencyDisplayCode={currencyDisplayCode}
                    locale={locale}
                />
            </React.Fragment>
        );
    }
}

// default props
CartModal.defaultProps = {
    isLoading: false,
    list: [],
    tax: 0,
    subtotal: 0,
    total: 0,
    currencyFormat: '0,0.00',
    currencyDisplayCode: 'AU$',
    locale: 'en_AU',
};
// validate props
CartModal.propTypes = {
    isLoading: PropTypes.bool,
    list: PropTypes.array,
};

export default CartModal;
